<template lang="pug">
v-container(fluid).re-filters
  v-row(wrap)
    v-col(cols="12" md="3" tile)
      filter-autocomplete-loaded(
        v-model="model.filters[FILTERS_ATTR.EXAM_LOCATION]" 
        :getItems="getExamLocations"
        multiple
        showCloseMenuBtn
        closeOnInputClick
        label="Location"
        hideDetails
        showSelectedIcon
        testName="res-location-input"
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )
    v-col(cols="12" md="3" tile)
      datepicker(
        v-model="model.filters[FILTERS_ATTR.EXAM_DATE_TO]"
        :disabled="filterByCourse"
        hideDetails
        testName="res-date-to"
        label="Exam date"
      )
      v-switch(
        v-model="filterByCourse"
        label="Filter by course?"
      )
      datepicker(
        v-model="courseDate"
        :disabled="!filterByCourse"
        @input="loadCoursesAfterClick(courseDate)"
        hideDetails
        label="Selected course date"
      )
      autocompleteChecked(
        v-model="model.filters[FILTERS_ATTR.COURSE]"
        :multiple="true"
        showCloseMenuBtn
        :disabled="!filterByCourse"
        :items="courses"
        item-text="label"
        item-value="id"
        label="Course"
      )
      
    v-col(cols="12" md="3" tile)
      filter-autocomplete-loaded(
        v-model="model.filters.product" 
        :getItems="getProductNames"
        label="Product name"
        itemText="name"
        showClearBtn
        itemValue="name"
        showSelectedIcon
        hideDetails
        showCloseMenuBtn
        closeOnInputClick
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )
    v-col(cols="12" md="3" tile)
      filter-autocomplete-loaded(
        v-model="model.filters.type"
        :getItems="getCbrTypes"
        label="Type"
        showClearBtn
        showSelectedIcon
        hideDetails
        showCloseMenuBtn
        closeOnInputClick
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )      
      
  
  v-btn(outlined data-test="res-submit" @click="checkOnValid").btn-common Apply
  search(
    v-model="model.filters.search"
    placeholder="Search by candidate data"
    @change="checkOnValid"
  ).mt-3.res-search
  div.flex.justify-between.mt-3
    monitoring(@monitoringStatusChanged="isMonitoringStarted = $event")
    v-btn.get-results-btn.btn-common(outlined @click="getResults" :disabled="resultsDisabled || isMonitoringStarted") Get Results
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import FiltersModel, {FILTERS_ATTR, FILTERS_ARGS} from "../core/models/ResultsFiltersModel.js"
import { CBR_TYPES, RESULT_FILTERS } from '../core/results-const'
import ErrorMixin from "@/mixins/errors.mixin"
import ResultDefaultFilters from "../core/models/resultDefaultFilters"
import Repo from "@/services/api/util/auth-repo-local-storage"

export default {
  mixins: [ ErrorMixin ],
  data: () =>({
    model: null,
    FILTERS_ATTR: FILTERS_ATTR,
    resultsDisabled: false,
    isMonitoringStarted: false,
    filterByCourse: false,
    courseDate: null,
  }),

  created() {
    this.init()
  },

  computed: {
    ...mapGetters({
      courses: 'allCourses/items'
    })
  },

  async mounted() {
    this.checkOnFilterByCourse()
    await this.setDefaultQuery()
    if(this.courseDate) this.loadCourses(this.courseDate)
    
  },

  inject: ['getDefaultPagination', 'svc'],

  methods: {
    ...mapActions({
      getExamLocations: 'crmExamLocation/list',
      getProductNames: 'crmProductNames/list',
      loadAllCourses: 'allCourses/list'
    }),

    async getResults() {
      try {
        this.resultsDisabled = true;
        await this.svc.loadResults({query: {...this.getDefaultPagination(), ...this.model.getApiData({
          courseDate: this.courseDate, filterByCourse: this.filterByCourse, ordering: this.$route.query.ordering
        })}})
        this.$notify({type: 'success', text: 'Get results request send'})
      } catch (error) {
        this.processError(error);
      } finally {
        setTimeout(() => {
          this.resultsDisabled = false;
        }, 2000)
      }
    },

    getCbrTypes() {
      return Object.values(CBR_TYPES)
    },

    init() {
      this.repo = new Repo()
      let query = !(Object.keys(this.$route.query).length) ? new ResultDefaultFilters(this.repo, this.$route.query).get()  : this.$route.query
      this.model = new FiltersModel(query)
    },
    
    async setDefaultQuery() {
      this.setDefaultExamDate()
      await this.filtersChanged()
    },

    setDefaultExamDate() {
      if(this.model.filters[FILTERS_ATTR.EXAM_DATE_TO]) return
      this.model.setDefaultExamDate()
    },

    async setQuery() {
      try {
        await this.$router.replace({query: {
          ...this.getDefaultPagination(), 
          ...this.model.getApiData({courseDate: this.courseDate, filterByCourse: this.filterByCourse}),
          ordering: this.$route.query.ordering
        }})
      } catch (error) {
        console.log(error)
      }
    },

    async filtersChanged() {
      await this.setQuery()
      this.$emit('filterChanged')

    },

    saveToRepo() {
      this.repo.store(RESULT_FILTERS, this.$route.query)
    },

    checkOnFilterByCourse() {
      if(this.model.filters.course && this.model.filters.course_date) {
        this.filterByCourse = true
        this.courseDate = this.model.filters.course_date
        
      } 
    },

    loadCoursesAfterClick(date) {
      this.model.filters[FILTERS_ATTR.COURSE] = []
      this.loadCourses(date)
    },

    async loadCourses(date) {
      try {
        await this.loadAllCourses({query: {
          date_after: date,
          date_before: date
        }})
      } catch (error) {
        this.processError(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
        });
      }
    },

    async checkOnValid() {
      if(this.filterByCourse && (!this.courseDate || !this.model.filters[FILTERS_ATTR.COURSE].length)) 
        return this.$notify({type: 'error', text: "Course date or course not selected"})
      await this.filtersChanged()
      this.saveToRepo()
    }
  },

  components: {
    FilterAutocomplete: () => import('@/app/admin/components/FilterAutocompleteChecked.vue'),
    Datepicker: () => import('@/app/admin/components/CrmDatepicker.vue'),
    FilterAutocompleteLoaded: () => import('@/components/global/FilterAutocomplete.vue'),
    autocompleteChecked: () => import('@/app/admin/components/FilterAutocompleteChecked.vue'),
    Search: () => import('@/components/global/Search.vue'),
    monitoring: () => import('./ResultsMonitoring.vue')

  }
}
</script>

<style lang="scss" scoped>
.res-search {
  box-shadow: 0 1px 1px 0px #ccc;
}

.get-results-btn{
  margin-left: 16px;
}

.flex{
  display: flex;
}

.justify-between{
  justify-content: space-between;
}

.re-filters {
  padding-left: 14px;
  padding-right: 14px;
}

.search::v-deep {
  &.v-input .v-text-field__slot input {
    padding: 8px 0 8px;
    // padding: 0 !important;
  }
}
</style>